import React from 'react'
import Icon from '../Icon/Icon'

export interface ProgressTitleProps {
    id: string | number
    current?: string | number
    index?: number
    titleCount?: number
    withNumber?: boolean
}

const ProgressTitle: React.FC<ProgressTitleProps> = ({ titleCount, withNumber, index, children, current, id }) => {
    // if (current !== id) {
    //     return null
    // }
    const isActive = current === id ? 'r-state-active' : ''

    const renderIcon = index < titleCount - 1

    return (
        <React.Fragment>
            <div className={`r-progress-title ${isActive}`}>
                {withNumber ? <span className={'r-progress-title-num'}>{index + 1}.</span> : null}
                {children}
            </div>
            {renderIcon ? <Icon type={'arrow-right'} /> : ''}
        </React.Fragment>
    )
}

export default ProgressTitle
